module.exports = __webpack_public_path__ + "static/media/plus-preto.08859ac5.webp";